import React from "react";
import {Route, Switch} from "react-router-dom";

import store from "./store";
import Config from "./config";
import QuoteDesignPage from "./bvcomponents/quoteDesign/quoteDesignPage";
import InitialFlow from "./bvcomponents/initialFlow/initialFlow";
import InitialFlowType from "./bvcomponents/initialFlow/initialFlowType";
import InitialFlowRoom from "./bvcomponents/initialFlow/initialFlowRoom";
import InitialFlowLayout from "./bvcomponents/initialFlow/initialFlowLayout";
import IntroVideo from "./bvcomponents/introVideo";
// import ProjectScope from "./bvcomponents/projectScope/projectScope";
import SelectionWindowPage from "./bvcomponents/selectionWindow/selectionWindowPage";
import ShoppingCartView from "./bvcomponents/shoppingCart/shoppingCartView";
import {ROUTES} from "./routes";
import ContractsPopup from "./bvcomponents/popups/contractSign/contractsPopup";
// import SquareFootageTool from "./bvcomponents/sqft/squareFootageTool"; // OLD

let _initialFlowVisited = false;

const inititalFlowOnEnter = () => {
  _initialFlowVisited = true;
};

const checkForInitialFlow = (nextState, replace) => {
  if (Config.isTutorial() && !_initialFlowVisited) {
    replace("/wizard");
  }
};

const visualizerOnEnter = (nextState, replace) => {
  document.kvConfig.visualizerEntered = true;
  checkForInitialFlow(nextState, replace);
};

const checkForVisualizerOnly = (nextState, replace) => {
  const state = store.getState();
  if (state.fabricatorState.received && document.kvConfig.visualizerOnly) {
    replace("/visualizer");
    return true
  }
  return false
};

const newScopeOnEnter = (nextState, replace) => {
  if (!checkForVisualizerOnly(nextState, replace)) {
    checkForInitialFlow(nextState, replace);
  }
};

const materialsPageOnEnter = (nextState, replace) => {
  if (!checkForVisualizerOnly(nextState, replace)) {
    checkForInitialFlow(nextState, replace);
  }
  const state = store.getState();
  if (state.fabricatorState.received && state.fabricatorState.settings.showTutorialVideo
    && !state.serverState.introVideo.introVideoFinished) {
    replace("/tutorial-intro/1");
  }
  // if (!_initialFlowVisited) {
  //   if (document.kvConfig.initialFlowEnabled) {
  //     replace("/wizard");
  //   } else {
  //     replace("/newscope");
  //   }
  // }
};

const shoppingCartOnEnter = (nextState, replace) => {
  if (!checkForVisualizerOnly(nextState, replace)) {
    checkForInitialFlow(nextState, replace);
  }
};

const QKBRoutes = () => (
  <Switch>
    {/*<IndexRoute component={ProjectScope} onEnter={newScopeOnEnter}/>*/}
    <Route exact path={ROUTES.home} component={QuoteDesignPage} onEnter={newScopeOnEnter}/>
    <Route exact path={ROUTES.quoteDesign} component={QuoteDesignPage} onEnter={newScopeOnEnter}/>
    <Route path={ROUTES.wizard} component={InitialFlow} onEnter={inititalFlowOnEnter}>
      <Route exact path={ROUTES.wizard} component={InitialFlowType}/>
      <Route path="room" component={InitialFlowRoom}/>
      <Route path="layout" component={InitialFlowLayout}/>
    </Route>
    <Route path="/tutorial-intro/:step" component={IntroVideo} onEnter={shoppingCartOnEnter}/>
    {/*<Route path={ROUTES.newscope} component={ProjectScope} onEnter={newScopeOnEnter}/>*/}
    <Route exact path="/materials" component={SelectionWindowPage} onEnter={materialsPageOnEnter}/>
    <Route exact path="/materials/:partName/" component={SelectionWindowPage} onEnter={materialsPageOnEnter}/>
    <Route path="/materials/:partName/:subPartName" component={SelectionWindowPage} onEnter={materialsPageOnEnter}/>
    <Route path={ROUTES.shoppingcart} component={ShoppingCartView} onEnter={shoppingCartOnEnter}/>
    <Route path={ROUTES.visualizer} component={SelectionWindowPage} onEnter={visualizerOnEnter}/>
    <Route path={ROUTES.contract} component={ContractsPopup}/>
  </Switch>
)

export default QKBRoutes
